module.exports = __webpack_public_path__ + "img/palladium@2x.939a909.webp";